export default __webpack_public_path__ + "static/media/pay-bills-hero.a547176d.png";